package com.wintermar.inspection.feature.presentation.inspection.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.RectangleShape
import com.wintermar.inspection.core.ui.component.TextBodyRegular
import com.wintermar.inspection.core.ui.component.datetime.util.DateTimeUtil
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.core.ui.widget.CardInfo
import com.wintermar.inspection.core.ui.widget.IconText
import com.wintermar.inspection.feature.util.inspection_status.InspectionStatusView
import com.wintermar.inspection.graphql.type.InspectionStatus
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.answered_questions
import inspection.composeapp.generated.resources.flagged_items
import inspection.composeapp.generated.resources.ic_time
import inspection.composeapp.generated.resources.last_updated
import org.jetbrains.compose.resources.stringResource

@Composable
fun InspectionHeaderInfo(
    totalAnswer: Int,
    totalFlaggedAnswer: Int,
    totalQuestion: Int,
    templateName: String,
    lastUpdateIsoUtc0: String,
    status: InspectionStatus,
    withTopRadius: Boolean = false,
    hideCardInfo: Boolean = false,
) {
    val color: ThemeColor = LocalAppTheme.current.color
    val dimension: AppDimension = LocalAppTheme.current.dimension

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(
                color = color.surface.neutral.subtle.default,
                shape = if (!withTopRadius) RectangleShape else RoundedCornerShape(
                    topStart = dimension.radius.md,
                    topEnd = dimension.radius.md
                )
            )
            .padding(dimension.spacing.space4),
        verticalArrangement = Arrangement.spacedBy(
            space = dimension.spacing.space4
        )
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(
                space = dimension.spacing.space2
            )
        ) {
            Column(
                modifier = Modifier.weight(1f),
                verticalArrangement = Arrangement.spacedBy(
                    space = dimension.spacing.space1
                )
            ) {
                TextBodyRegular(
                    text = templateName,
                    bold = true
                )

                IconText(
                    isTiny = true,
                    icon = Res.drawable.ic_time,
                    text = "${stringResource(Res.string.last_updated)} ${
                        DateTimeUtil.getLocalSystemDisplay(
                            lastUpdateIsoUtc0
                        )
                    }",
                    tint = color.icon.subtle
                )
            }

            InspectionStatusView(
                status = status,
                asBadge = true
            )
        }

        if (!hideCardInfo) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(
                    space = dimension.spacing.space4
                )
            ) {
                CardInfo(
                    label = stringResource(Res.string.flagged_items),
                    value = totalFlaggedAnswer.toString(),
                    modifier = Modifier.weight(1f)
                )

                CardInfo(
                    label = stringResource(Res.string.answered_questions),
                    value = "${totalAnswer}/${totalQuestion}",
                    modifier = Modifier.weight(1f)
                )
            }
        }
    }
}
